import { gql, useMutation } from '@apollo/client';

import {
  SessionIntentionNotificationCadence,
  SessionIntentionNotificationTimeOfDay,
} from '@grow-therapy-team/seedling-components';

import { Server } from '../../apollo/types';
import { SessionIntention } from './types';

interface UpdateSessionIntentionData {
  updateSessionIntention: {
    sessionIntention: SessionIntention;
  };
}

interface UpdateSessionIntentionVariables {
  sessionIntentionShortId: string;
  contentText?: string;
  notificationCadence?: SessionIntentionNotificationCadence | null;
  notificationTimeOfDay?: SessionIntentionNotificationTimeOfDay | null;
}

const updateSessionIntentionDocument = gql`
  mutation UpdateSessionIntention(
    $sessionIntentionShortId: String!
    $contentText: String
    $notificationCadence: SessionIntentionNotificationCadence
    $notificationTimeOfDay: SessionIntentionNotificationTimeOfDay
  ) {
    updateSessionIntention(
      sessionIntentionShortId: $sessionIntentionShortId
      contentText: $contentText
      notificationCadence: $notificationCadence
      notificationTimeOfDay: $notificationTimeOfDay
    ) {
      sessionIntention {
        shortId
        appointmentShortId
        clientUserShortId
        providerShortId
        contentText
        contentImageUrl
        notificationCadence
        notificationTimeOfDay
        expiredAt
      }
    }
  }
`;

export function useUpdateSessionIntentionMutation() {
  return useMutation<UpdateSessionIntentionData, UpdateSessionIntentionVariables>(updateSessionIntentionDocument, {
    context: {
      server: Server.MONOLITH,
    },
  });
}
